import axiosInstance from "../api/axiosInstance";

const ENDPOINTS = {
  GET_OZET: "/GetOzet",
  GET_OZET_EXCEL: "/GetOzetEXCEL", // Eğer kullanılmayacaksa silebilirsin.
  GET_FULL_REPORT: "/FullRaporExport2",
  GET_SUMMARY: "/Summary",
  GET_WASTE_EXCEL: "/PosetVermeAlmaRaporlari",
  GET_VISIT_EXCEL: "/ZiyaretciRaporlari",
  GET_VISITED_EXCEL: "/TaskToNewPersonelExport",
  GET_SOFOR_REPORT: "/SoforRaporlari",
  GET_ZIYARETCI_RAPORLARI_ORANLI: "/ZiyaretciRaporlariORANLI",
  GET_HAKEDIS_REPORT: "/HakedisListesi",
  GET_GOREV_ATAMA_RAPORU: "/GorevAtamaRaporu",
};

// Özet verileri çekmek için başlangıç ve bitiş tarihlerini alan fonksiyon
export const getOzet = async ({ startDate, endDate }) => {
  const params = new URLSearchParams();

  if (startDate) params.append("basla", startDate);
  if (endDate) params.append("bitir", endDate);

  const url = `${ENDPOINTS.GET_OZET}?${params.toString()}`;
  const response = await axiosInstance.get(url);
  return response.data;
};

export const getSummary = async ({ startDate, endDate} = {}) => {
  const params = new URLSearchParams();
  if (startDate) params.append("basla", startDate);
  if (endDate) params.append("bitir", endDate);
   params.append("Pagenumber", 1);
   params.append("PageSize", 60000);

  const url = `${ENDPOINTS.GET_SUMMARY}?${params.toString()}`;
  const response = await axiosInstance.get(url);
  return response.data;
};

// Excel raporu indirmek için tarih aralığı alan fonksiyon
export const getFullReport = async ({ startDate, endDate } = {}) => {
  const searchParams = new URLSearchParams();

  if (startDate) searchParams.append("basla", startDate);
  if (endDate) searchParams.append("bitir", endDate);

  const url = `${ENDPOINTS.GET_FULL_REPORT}?${searchParams.toString()}`;

  const response = await axiosInstance.get(url, {
    responseType: "blob",
  });

  if (response.status !== 200) {
    throw new Error("Rapor indirme işlemi başarısız oldu");
  }

  return response;
};

export const getWasteReport = async ({ startDate, endDate } = {}) => {
  const searchParams = new URLSearchParams();

  if (startDate) searchParams.append("basla", startDate);
  if (endDate) searchParams.append("bitir", endDate);

  const url = `${ENDPOINTS.GET_WASTE_EXCEL}?${searchParams.toString()}`;

  const response = await axiosInstance.get(url, {
    responseType: "blob",
  });

  if (response.status !== 200) {
    throw new Error("Rapor indirme işlemi başarısız oldu");
  }

  return response;
};
export const getVisitedReport = async () => {
 

  const url = `${ENDPOINTS.GET_VISITED_EXCEL}`;

  const response = await axiosInstance.get(url, {
    responseType: "blob",
  });

  if (response.status !== 200) {
    throw new Error("Rapor indirme işlemi başarısız oldu");
  }

  return response;
};
export const getSoforReport = async ({ baslangicTarihi, bitisTarihi, ilce, mahalle, sokak } = {}) => {
  const searchParams = new URLSearchParams();
  if (baslangicTarihi) searchParams.append("baslangicTarihi", baslangicTarihi);
  if (bitisTarihi) searchParams.append("bitisTarihi", bitisTarihi);
  if (ilce) searchParams.append("ilce", ilce);
  if (mahalle) searchParams.append("mahalle", mahalle);
  if (sokak) searchParams.append("sokak", sokak);
  searchParams.append("topN", 10000000);

  const url = `${ENDPOINTS.GET_SOFOR_REPORT}?${searchParams.toString()}`;

  const response = await axiosInstance.get(url, {
    responseType: "blob",
  });

  if (response.status !== 200) {
    throw new Error("Rapor indirme işlemi başarısız oldu");
  }

  return response;
};

// Hakediş Listesi - hafta/mahalle bazlı hane başarı raporu (Excel döner)
export const getHakedisReport = async ({ startDate, endDate, ilce, mah, tamHafta } = {}) => {
  const searchParams = new URLSearchParams();

  if (startDate) searchParams.append("basla", startDate);
  if (endDate) searchParams.append("bitir", endDate);
  if (ilce) searchParams.append("ilce", ilce);
  if (mah) searchParams.append("mah", mah);
  if (tamHafta !== undefined) searchParams.append("tamHafta", tamHafta);

  const url = `${ENDPOINTS.GET_HAKEDIS_REPORT}?${searchParams.toString()}`;

  const response = await axiosInstance.get(url, {
    responseType: "blob",
  });

  if (response.status !== 200) {
    throw new Error("Rapor indirme işlemi başarısız oldu");
  }

  return response;
};

export const getVisitReport = async ({ startDate, endDate, filtrele, ilce, mah } = {}) => {
  const searchParams = new URLSearchParams();
  if (startDate) searchParams.append("basla", startDate);
  if (endDate) searchParams.append("bitir", endDate);
  if (filtrele) searchParams.append("filtrele", filtrele);
  if (ilce) searchParams.append("ilce", ilce);
  if (mah) searchParams.append("mah", mah);

  const url = `${ENDPOINTS.GET_VISIT_EXCEL}?${searchParams.toString()}`;

  const response = await axiosInstance.get(url, {
    responseType: "blob",
  });

  if (response.status !== 200) {
    throw new Error("Rapor indirme işlemi başarısız oldu");
  }

  return response;
};

// (Opsiyonel) Eğer bu fonksiyon aktif olarak kullanılmıyorsa silebilirsin
export const getOzetExcel = async ({ startDate, endDate } = {}) => {
  const searchParams = new URLSearchParams();

  if (startDate) searchParams.append("startDate", startDate);
  if (endDate) searchParams.append("endDate", endDate);

  const url = `${ENDPOINTS.GET_OZET_EXCEL}?${searchParams.toString()}`;

  const response = await axiosInstance.get(url);
  return response.data;
};

// Ziyaretçi Raporları ORANLI - GET request with filters (returns Excel file)
export const getZiyaretciRaporlariOranli = async ({ basla, bitir, ilce, mah, personelids } = {}) => {
  const searchParams = new URLSearchParams();

  if (basla) searchParams.append("basla", basla);
  if (bitir) searchParams.append("bitir", bitir);
  if (ilce) searchParams.append("ilce", ilce);
  if (mah) searchParams.append("mah", mah);
  if (personelids) searchParams.append("personelids", personelids);

  const url = `${ENDPOINTS.GET_ZIYARETCI_RAPORLARI_ORANLI}?${searchParams.toString()}`;

  const response = await axiosInstance.get(url, {
    responseType: "blob",
  });

  if (response.status !== 200) {
    throw new Error("Rapor indirme işlemi başarısız oldu");
  }

  return response;
};

// API'deki sınırla aynı (VersionTwoController.GorevAtamaRaporuEnFazlaGun)
export const GOREV_ATAMA_RAPORU_EN_FAZLA_GUN = 93;

// responseType "blob" olduğunda API'nin hata gövdesi de blob gelir: { message } (400) veya
// HataYakalama'nın düz metni ("Hata: ..." ile başlar). Okunamazsa null döner.
export const raporHataMesaji = async (error) => {
  const data = error?.response?.data;
  if (!(data instanceof Blob)) return null;
  try {
    const metin = await data.text();
    try {
      return JSON.parse(metin)?.message || null;
    } catch {
      return metin.startsWith("Hata:") ? metin.split("\n")[0] : null;
    }
  } catch {
    return null;
  }
};

// Görev Atama Raporu - Görev Planlama'da verilen görevlerin geriye dönük dökümü (Excel, en çok 93 gün)
export const getGorevAtamaRaporu = async ({ basla, bitir, ilce, mah, personelids } = {}) => {
  const searchParams = new URLSearchParams();

  if (basla) searchParams.append("basla", basla);
  if (bitir) searchParams.append("bitir", bitir);
  if (ilce) searchParams.append("ilce", ilce);
  if (mah) searchParams.append("mah", mah);
  if (personelids) searchParams.append("personelids", personelids);

  const url = `${ENDPOINTS.GET_GOREV_ATAMA_RAPORU}?${searchParams.toString()}`;

  const response = await axiosInstance.get(url, {
    responseType: "blob",
  });

  if (response.status !== 200) {
    throw new Error("Rapor indirme işlemi başarısız oldu");
  }

  return response;
};
